export const wait = (secs: number) =>
  new Promise(resolve => setTimeout(resolve, secs * 1000));
